import {
    Component,
    Input,    TemplateRef,
    ViewChild
} from '@angular/core';
import { Layout } from '../../baseObjects/layout';

@Component({
    selector: 'button',
    templateUrl: 'button.component.html',
    host: { 'class': 'button component' }
})
export class ButtonComponent extends Layout {
    // io
    @Input() text: string;
    @Input() icon: string;
    @Input() template: string;

    // view childs
    @ViewChild('contentTemplate') contentTemplate: TemplateRef<any>;
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/button/button.component.ts